import { ThemeProvider } from '@gasbi/shared/web/providers/ThemeProvider';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import store from '@/app/store';
import { routes } from '@/routes';

const router = createBrowserRouter(routes);

export const App = () => (
  <Provider store={store}>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </Provider>
);
